import { render, staticRenderFns } from "./TarjetaTiempoActividad.vue?vue&type=template&id=297c86f0&scoped=true"
import script from "./TarjetaTiempoActividad.vue?vue&type=script&lang=js"
export * from "./TarjetaTiempoActividad.vue?vue&type=script&lang=js"
import style0 from "./TarjetaTiempoActividad.vue?vue&type=style&index=0&id=297c86f0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "297c86f0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VAvatar,VCard,VCardText,VCol,VIcon,VRow})
